import { render } from "./AddOrEditSpecialProjectPage.vue?vue&type=template&id=1b08ef68&ts=true"
import script from "./AddOrEditSpecialProjectPage.vue?vue&type=script&lang=ts"
export * from "./AddOrEditSpecialProjectPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__